import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import {
  ScopeOfPracticeEnum,
  SCOPE_OF_PRACTICE_ENUM_RECORD
} from '@umss/shared/utils';
import { UmssBadgeComponent } from '../badge/badge.component';
import { UmssTooltipDirective } from '../../directives/tooltip.directive';

/**
 * Component to display a badge based on scope of practice.
 * Shows abbreviated scope (e.g., "RN") with a tooltip showing the full name (e.g., "Registered Nurse").
 */
@Component({
  selector: 'umss-scope-of-practice-badge',
  standalone: true,
  imports: [UmssBadgeComponent, UmssTooltipDirective],
  template: `
    @if (scope && fullName) {
      <umss-badge
        [variant]="'secondary'"
        [label]="scope.toUpperCase()"
        [outlined]="true"
        [umssTooltip]="fullName"
        tooltipPosition="top"
        [size]="size"
      />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UmssScopeOfPracticeBadgeComponent {
  private _scope!: ScopeOfPracticeEnum;

  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input({ required: true }) set scope(value: ScopeOfPracticeEnum | string) {
    if (
      !Object.values(ScopeOfPracticeEnum).includes(value as ScopeOfPracticeEnum)
    )
      return;

    this._scope = value as ScopeOfPracticeEnum;
    this.fullName = SCOPE_OF_PRACTICE_ENUM_RECORD[this._scope];
  }
  get scope(): ScopeOfPracticeEnum {
    return this._scope;
  }

  fullName: string | undefined;
}
